import { createContext } from 'react';
import { StepperContextValues } from './types/StepperContextValues';

const OrderDetailsStepperContext = createContext<StepperContextValues | undefined>(undefined);

export const OrderDetailsStepperProvider = OrderDetailsStepperContext.Provider;

export default OrderDetailsStepperContext;
